<button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5">
    <img src="assets/images/users/default-profile.png" alt="user" class="profile-pic"> </button>
<mat-menu #profile="matMenu" class="mymegamenu">
    <button mat-menu-item (click)="onLoggedout()">
        <mat-icon>exit_to_app</mat-icon> Sign Out
    </button>
</mat-menu>